import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-5b7a3146"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "page-main"
};
const _hoisted_2 = ["src"];
const _hoisted_3 = {
  class: "down-main"
};
const _hoisted_4 = {
  class: "img-main"
};
const _hoisted_5 = ["src"];
const _hoisted_6 = ["src"];

const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "app-title"
}, "甜心公园", -1));

const _hoisted_8 = /*#__PURE__*/_createStaticVNode("<div class=\"beian\" data-v-5b7a3146><div data-v-5b7a3146>网站备案/许可证号：<a class=\"beian-link\" target=\"_blank\" href=\"http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=44010602013692\" data-v-5b7a3146><span class=\"beian-color\" data-v-5b7a3146>粤公网安备 44010602013692号</span></a></div><div data-v-5b7a3146>网站备案/许可证号：<a class=\"beian-link\" target=\"_blank\" href=\"https://beian.miit.gov.cn/\" data-v-5b7a3146><span class=\"beian-color\" data-v-5b7a3146>琼ICP备2024042973号-3</span></a></div><div data-v-5b7a3146>违法和不良信息举报邮箱：<span class=\"beian-color\" data-v-5b7a3146>tianxinkefu@163.com</span></div></div>", 1);

const _hoisted_9 = ["src"];
const _hoisted_10 = {
  class: "tips-val"
};
const _hoisted_11 = {
  class: "share-desc"
};

const _hoisted_12 = /*#__PURE__*/_createTextVNode(" 点击右上角");

const _hoisted_13 = ["src"];
const _hoisted_14 = {
  class: "share-desc"
};

const _hoisted_15 = /*#__PURE__*/_createTextVNode(" 选择\"浏览器中打开\"");

const _hoisted_16 = ["src"];
const _hoisted_17 = ["src"];
const _hoisted_18 = {
  key: 1,
  class: "hide_back"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", null, [_createElementVNode("div", _hoisted_1, [_createElementVNode("img", {
    src: $setup.down_back,
    class: "down-back"
  }, null, 8, _hoisted_2), _createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createElementVNode("img", {
    src: $setup.mid,
    class: "mid-img"
  }, null, 8, _hoisted_5)]), _createElementVNode("img", {
    src: $setup.icon,
    class: "app-icon"
  }, null, 8, _hoisted_6), _hoisted_7, _createElementVNode("div", {
    class: "down-btn btn-back",
    onClick: _cache[0] || (_cache[0] = (...args) => $setup.down && $setup.down(...args))
  }, " Android 下载 ")]), _hoisted_8]), $setup.isWechat && $setup.show ? (_openBlock(), _createElementBlock("div", {
    key: 0,
    class: "share-back",
    onClick: _cache[1] || (_cache[1] = (...args) => $setup.close && $setup.close(...args))
  }, [_createElementVNode("img", {
    src: $setup.wechatjt,
    class: "wechatjt"
  }, null, 8, _hoisted_9), _createElementVNode("div", _hoisted_10, [_createElementVNode("div", _hoisted_11, [_hoisted_12, _createElementVNode("img", {
    src: $setup.share_point,
    class: "point"
  }, null, 8, _hoisted_13)]), _createElementVNode("div", _hoisted_14, [_hoisted_15, $setup.isIos ? (_openBlock(), _createElementBlock("img", {
    key: 0,
    src: $setup.safari,
    class: "safari"
  }, null, 8, _hoisted_16)) : (_openBlock(), _createElementBlock("img", {
    key: 1,
    src: $setup.liulan,
    class: "safari"
  }, null, 8, _hoisted_17))])])])) : _createCommentVNode("", true), $setup.isWechat && $setup.show ? (_openBlock(), _createElementBlock("div", _hoisted_18)) : _createCommentVNode("", true)]);
}